import { ISupplier } from './../interfaces/ISupplier';
import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';
import { IPaginationResponse } from 'interfaces/responces/IPagination.response';
import { IFilter } from 'interfaces/IFilter';

export const supplierApi = createApi({
  reducerPath: 'supplierApi',
  tagTypes: ['Supplier'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getSuppliersList: build.query<
      IPaginationResponse<ISupplier[]>,
      IFilter
    >({
      transformResponse: (response: { data: IPaginationResponse<ISupplier[]> }) =>
        response.data,
      query: ({ page, search, query, limit }) => ({
        url: '/suppliers/list',
        method: 'GET',
        params: {
          page,
          search,
          limit,
        },
      }),
      providesTags: () => ['Supplier'],
    }),
    getSuppliersShortList: build.query<ISupplier[], any>({
      transformResponse: (response: { data: ISupplier[] }) => response.data,
      query: () => ({
        url: '/suppliers/short-list',
        method: 'GET',
      }),
      providesTags: () => ['Supplier'],
    }),
    createSupplier: build.mutation<ISupplier, any>({
      transformResponse: (response: { data: ISupplier }) => response.data,
      query: (newSupplier) => ({
        url: '/suppliers/create',
        method: 'POST',
        body: newSupplier,
      }),
      invalidatesTags: ['Supplier'],
    }),
    updateSupplier: build.mutation<ISupplier, { supplier: any; id: any }>({
      transformResponse: (response: { data: ISupplier }) => response.data,
      query: (data) => ({
        url: `/suppliers/${data.id}`,
        method: 'POST',
        body: data.supplier,
      }),
      invalidatesTags: ['Supplier'],
    }),
    deleteSupplier: build.mutation<ISupplier, number>({
      query: (supplierId) => {
        return {
          url: `/suppliers/${supplierId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Supplier'],
    }),
    blockUnblockSupplier: build.mutation<ISupplier, any>({
      transformResponse: (response: { data: ISupplier }) => response.data,
      query: (data) => ({
        url: '/suppliers/block-unblock',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Supplier'],
    }),
  }),
});
